import { createSelector } from '@reduxjs/toolkit';

import { AssetContent_Study_CBCT_CBCT_Metadata } from '@/shared/api/protocol-ts/model/dto_asset_study_pb';
import { Study, StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';
import { StudyMetaInfo } from '@/shared/config/types';
import { getCBCTMetaData } from '@/shared/lib';

import { assetsModel } from '@/entities/assets';
import { studyModel } from '@/entities/study';

export const selectStudyInfo = (studyID: string) =>
  createSelector(
    studyModel.selectors.selectEntities,
    assetsModel.selectors.selectAll,
    (studyEntities, assets) => {
      if (!(studyID in studyEntities)) {
        return null;
      }

      const study = studyEntities[studyID] as Study;

      const CBCTMetaData =
        study.Type === StudyType.StudyType_CBCT
          ? getCBCTMetaData(study.ID)(assets)
          : ({} as AssetContent_Study_CBCT_CBCT_Metadata);

      const studyInfo: StudyMetaInfo = {
        ID: study.ID,
        studyType: study.Type,
        scanUID: CBCTMetaData?.ScanUID,
        manufacturer: CBCTMetaData?.Manufacturer,
        model: CBCTMetaData?.ManufacturerModelName,
        exposure: CBCTMetaData?.Exposure,
        fov: CBCTMetaData?.FOV,
        voxel: CBCTMetaData?.VoxelSize?.join(','),
        uploadDate: study.Created?.At?.toDate(),
        studyTime: study.Time?.toDate(),
      };

      return studyInfo;
    },
  );
